(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tipset/assets/javascripts/views/single-rows/single-matchlist.js') >= 0) return;  svs.modules.push('/modules/tipset/assets/javascripts/views/single-rows/single-matchlist.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.tipset.views.SingleMatchList = Backbone.Marionette.CollectionView.extend({
    className: 'matchlist-container bg-white',
    tagName: 'ul',
    childView: svs.tipset.views.SingleMatch,
    hasBomben: function() {
      var hasBomb = false;
      this.collection.each(function(match) {
        if (!_.isUndefined(match.get('isBomben'))) hasBomb = true;
      });
      return hasBomb;
    }
  });
})(Backbone, _, svs);

 })(window);